import { PlanEditGesture } from '@core/models/plan-edit-gesture.model';

/**
 * The gesture again, clearing in its own batch the company of the route DL refused it for, or `null`
 * when clearing would not answer the refusal. A company the planner picked is never cleared for
 * them. An opened route is named by a uid DL minted for the refused batch, so it is not matched.
 */
export function withCompanyCleared(
  gesture: PlanEditGesture,
  routeUid: string
): PlanEditGesture | null {
  const adding = (clears: string[] | undefined) => [
    ...new Set([...(clears ?? []), routeUid])
  ];
  switch (gesture.kind) {
    case 'set-resources':
      return gesture.resources.routeUid === routeUid
        ? { ...gesture, companyUid: null }
        : null;
    case 'swap-resources':
      return [gesture.a.routeUid, gesture.b.routeUid].includes(routeUid)
        ? { ...gesture, clearsCompanyOf: adding(gesture.clearsCompanyOf) }
        : null;
    case 'move-stop':
    case 'move-job':
    case 'move-tour':
      return gesture.placement.routeUid === routeUid
        ? { ...gesture, clearsCompanyOf: adding(gesture.clearsCompanyOf) }
        : null;
    case 'open-route':
      return gesture.companyUid === null ? null : { ...gesture, companyUid: null };
    default:
      return null;
  }
}
